import { render } from "./documents.vue?vue&type=template&id=630440e0"
import script from "./documents.vue?vue&type=script&lang=js"
export * from "./documents.vue?vue&type=script&lang=js"
script.render = render

export default script